export default "__VITE_ASSET__UyvsGq1n__"